import React, { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import { toLower, uniq } from 'lodash/fp';
import { text } from './Text';

const APPNAME = process.env.REACT_APP_NAME;

export default function Permission() {
  const context = useContext(AppContext);
  const {
    session: { userPermissions },
    application
  } = context;
  const { appConfig: { UN_AUTHORIZED_USER_MSG_PRIMARY } = {} } = application || [];

  let memo = UN_AUTHORIZED_USER_MSG_PRIMARY;
  const userAppNames = uniq(userPermissions.map((a) => a.split('.')[0]));
  const permissions = userAppNames.indexOf(toLower(APPNAME)) > -1;

  if (!permissions) {
    memo = text('common.access_denied');
  }
  //Decode the email address on view
  const decodedMailto = window.atob(text('common.permission_access_denied_email'));

  return (
    <div className="col-12 align-center">
      <p className="align-center content-page-title">{memo}</p>
      <p>
        {text('common.no_role_message')}
        {text('common.contact_help_desk1')}
        <a href={decodedMailto} className="mx-1" target="_top">
          {text('common.contact_help_desk2')}
        </a>
        {text('common.contact_help_desk3')}
      </p>
    </div>
  );
}
